import { render } from "./App.vue?vue&type=template&id=610116a0"
const script = {}
script.render = render

export default script